import { Base64 } from 'js-base64';

const Fetchs3image = ({bucket,key,width}) => {
  var directUrl = 'https://d2kqbuer1ivnwd.cloudfront.net/';
  var url = 'https://d7mg1um0fnnbi.cloudfront.net/';
  var obj = {
    "bucket": bucket,
    "key": key,
    "edits": {
      "resize": {
        "width": width ? width : 1200,
        "fit": "cover"
      },
      "contentModeration": {
          "minConfidence": 90,   // minimum confidence level for inappropriate content
          "blur": 80,            // amount to blur image
          "moderationLabels": [ // labels to search for
              "Hate Symbols",
              "Smoking",
              "Explicit Nudity"
              ]
      }
    }
  }
  var encoded = Base64.encode(JSON.stringify(obj));
  var imageUrl = url + encoded;
  //var imageUrl = url + key;
  return imageUrl;
}

export default Fetchs3image;